
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonPipe } from './common.pipe';
import { HeaderComponent } from '../components/header/header.component';
import { BreadcrumbComponent } from '../components/breadcrumb/breadcrumb.component';
import { FooterComponent } from '../components/footer/footer.component';
import { SideNavComponent } from '../components/sideNav/sideNav.component';
import { LoaderComponent } from '../components/loader/loader.component';
import { VerifyEmailComponent } from '../components/verify-email/verify-email.component';
import { PaymentConfirmationComponent } from '../components/payment-confirmation/payment-confirmation.component';
import { ResourcesSliderComponent } from '../components/resources-slider/resources-slider.component';
import { NgxFileDropModule } from 'ngx-file-drop';
// import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgSelectModule } from '@ng-select/ng-select';
import { SanitizedHtmlPipe } from '../_helpers/sanitized-html.pipe';
import { PhoneNumberMaskDirective } from './phone-number-mask.directive';
import { LandingComponent } from '../components/landing-component/landing/landing.component';
import { NotFoundComponent } from '../components/not-found/not-found.component';
import { SurveyFormComponent } from '../components/survey-form/survey-form/survey-form.component';
import { CreatingWillComponent } from '../components/creating-will/creating-will/creating-will.component';
import { LazyLoadImageDirective } from './lazy-load-image.directive';
import { CharitiesComponent } from '../components/charities/charities/charities.component';
import { PagenationComponent } from '../components/pagenation/pagenation/pagenation.component';
import { AllOrgsModalComponent } from '../components/all-orgs-modal/all-orgs-modal/all-orgs-modal.component';
import { MyOrgBreadcrumbComponent } from '../components/my-org-breadcrumb/my-org-breadcrumb/my-org-breadcrumb.component';
import { ViewPageModalComponent } from '../components/view-page-modal/view-page-modal/view-page-modal.component';
import { BenificaryNewCharityComponent } from '../components/benificary-new-charity/benificary-new-charity/benificary-new-charity.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { Will4HelpSectionComponent } from '../components/will4-help/will4-help-section.component';
import { Will4LegacyHelpSectionComponent } from '../components/will4-legacy/will4-legacy-help-section.component';
import { Will4HowItWorksSectionComponent } from '../components/will4-how-it-works/will4-how-it-works-section.component';
import { Will4HealthcareHowItWorksSectionComponent } from '../components/will4-healthcare-how-it-works/will4-healthcare-how-it-works-section.component';
// import { PaymentMethodComponent } from '../pages/payment-method/payment-method.component';


const COMPONENTS = [
    HeaderComponent,
    FooterComponent,
    BreadcrumbComponent,
    SideNavComponent,
    LoaderComponent,
    VerifyEmailComponent,
    PaymentConfirmationComponent,
    ResourcesSliderComponent,
    LandingComponent,
    NotFoundComponent,
    SurveyFormComponent,
    CreatingWillComponent,
    CharitiesComponent,
    PagenationComponent,
    AllOrgsModalComponent,
    MyOrgBreadcrumbComponent,
    ViewPageModalComponent,
    BenificaryNewCharityComponent,
    Will4HelpSectionComponent,
    Will4LegacyHelpSectionComponent,
    Will4HowItWorksSectionComponent,
    Will4HealthcareHowItWorksSectionComponent
]

// const BASE_MODULES = [CommonModule, FormsModule, ReactiveFormsModule, NgxFileDropModule, RecaptchaModule, RecaptchaFormsModule, CarouselModule, NgSelectModule];
const BASE_MODULES = [CommonModule, FormsModule, ReactiveFormsModule, NgxFileDropModule, CarouselModule, NgSelectModule, ImageCropperModule];

const PIPES = [
    CommonPipe,
    SanitizedHtmlPipe
];

const Directive = [
    PhoneNumberMaskDirective,
    LazyLoadImageDirective
];

@NgModule({
    declarations: [...COMPONENTS, ...PIPES, ...Directive],
    // entryComponents: [...COMPONENTS],
    imports: [...BASE_MODULES],
    exports: [...BASE_MODULES, ...COMPONENTS, ...PIPES, ...Directive],
    providers: [DatePipe],
    // entryComponents: [...ENTRY_COMPONENTS],
})

export class SharedModule { }
